// This hook will extract either group_number or SSN
import { useEffect, useState } from "react";
import { UseRouteParamProps } from "../@types/hooksProps.types";
import useQuery from "./useQuery";

const useRouteParam = (searchString: UseRouteParamProps): string | number | undefined | null => {
	const [routeParam, setRouteParam] = useState<string | number>();
	const query = useQuery();

	useEffect(() => {
		if (query && query.get(searchString)) {
			if (searchString === "group_index") {
				setRouteParam(Number(query.get("group_index")) as number);
			} else {
				setRouteParam(query.get(searchString) as string);
			}
		}
	}, [query, searchString]);

	return routeParam ? routeParam : null;
};

export default useRouteParam;
